<ng-container *transloco="let t; prefix: 'shared.checkout.step-review'">

    @if(orderData?.total !== 0) {
        <div class="flex flex-col gap-4 mb-8">
                <h3 class="font-semibold">{{t('headers.billingInformation')}}</h3>
                <div class="bg-white rounded-md p-4">
                    <h4 class="h4 text-black mb-5">{{t('subheaders.'+ orderData?.invoiceType)}}</h4>
                    <div class="ng">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
                            @if(orderData?.invoiceType === ProofOfPaymentEnum.Invoice) {
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{ 'shared.checkout.step-buyer-info.labels.taxNumber'
                                    | transloco }}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.taxNumber }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{ 'shared.checkout.step-buyer-info.labels.companyName' | transloco }}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.representativeName }}
                                </p>
                            </div>
                            }
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.fullName')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.fullName }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.email')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.email }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.address')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.street }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.zipCode')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.postalCode }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.city')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.city }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.mobilePhone')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.phoneNumber1 }}</p>
                            </div>
                            <div class="flex justify-between border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.landLine')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ orderData?.billingAddress?.phoneNumber2 }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="font-semibold">{{t('headers.paymentDetails')}}</h3>
                <div class="bg-white rounded-md p-4">
                    <h4 class="h4 text-black mb-5">{{t('subheaders.creditDebitCard')}}</h4>
                    <div class="transition-all duration-500 overflow-hidden dropdown-active">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.cardNumber')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ cardData?.number }}</p>
                            </div>
                            <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.cardholderName')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ cardData?.nameOnCard }}</p>
                            </div>
                            <div class="flex justify-between border-b-gray-300 pb-[10px]">
                                <p class="flex-1">{{t('labels.expirationDate')}}</p>
                                <p class="flex-1 text-black font-semibold">{{ cardData?.expiryDate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    }
    <div class="flex flex-col gap-4">
        <ng-container [formGroup]="reviewForm">
            @if(!isFromCompleteStep && orderData?.total !== 0) {
                <div class="w-full p-4 border-gray-400 border rounded">
                    <label for="checkbox-selector-transaction-terms" class="checkbox-selector w-full">
                        <input
                        [formControlName]="'paymentsTermsAccepted'"
                        (change)="onTermsChange()"
                            type="checkbox"
                            class="hidden"
                            id="checkbox-selector-transaction-terms"
                            name="checkbox-selector-term"
                        />
                        <div class="checkbox-selector-content">
                            <span class="checkbox-selector-text text-black ml-4 font-normal">
                            {{ t("labels.readAndAccept") }}
                            <a [localizedRouterLink]="['/terms-and-conditions']" [queryParams]="{ documentType: 'terms-and-conditions' }"
                                target="_blank"
                                class="text-primary cursor-pointer font-bold"
                                >{{ t("labels.termsOfUseAndTransactions") }}</a
                            >
                            </span>
                        </div>
                    </label>
                </div>
            }
            @if (!isFromCompleteStep){
                <div class="w-full p-4 border-gray-400 border rounded">
                    <label for="checkbox-selector-terms" class="checkbox-selector w-full">
                        <input
                        [formControlName]="'serviceTermsAccepted'"
                        (change)="onTermsChange()"
                        type="checkbox"
                        class="hidden"
                        id="checkbox-selector-terms"
                        name="checkbox-selector-term"
                        />
                        <div class="checkbox-selector-content">
                            <span class="checkbox-selector-text text-black ml-4 font-normal">
                                {{ t("labels.readAndAccept") }}
                                <a [localizedRouterLink]="['/terms-and-conditions']" [queryParams]="{ documentType: termsDocumentType }" target="_blank"
                                class="text-primary cursor-pointer font-bold"
                                >{{ t("labels.serviceTermsAndConditions") }}</a
                                >
                            </span>
                        </div>
                    </label>
                </div>
                <span *ngIf="controlHasError('termsConditionsAccepted')" class="text-error">
                    {{ t("acceptTncError") }}
                </span>
            }
        </ng-container>
    </div>
</ng-container>